/* 98bookscart — automatic related products, one unit per selection; no price overrides. */
if (!customElements.get('bc-fbt')) {
  customElements.define('bc-fbt', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.rows = [...this.querySelectorAll('[data-item]')];
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('form').addEventListener('submit', e => this.add(e), options);
      this.addEventListener('change', e => {
        if (e.target.matches('[data-variant]')) this.updateRow(e.target.closest('[data-item]'), true);
        this.update();
      }, options);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section || !data.variant) return;
          const row = this.querySelector('[data-primary]');
          const select = row.querySelector('select');
          if ([...select.options].some(o => o.value === String(data.variant.id))) {
            select.value = String(data.variant.id);
            this.updateRow(row, true);
            this.update();
          }
        });
      }
      const currentVariant = document.getElementById('product-form-' + this.dataset.section)?.querySelector('[name="id"]')?.value;
      const primarySelect = this.querySelector('[data-primary] select');
      if (currentVariant && primarySelect && [...primarySelect.options].some(o => o.value === currentVariant)) {
        primarySelect.value = currentVariant;
      }
      this.rows.forEach(row => this.updateRow(row, false));
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.unsubscribe?.();
      this.initialized = false;
    }
    money(amount) {
      return new Intl.NumberFormat(this.dataset.locale || 'en-IN', {
        style: 'currency', currency: this.dataset.currency || 'INR'
      }).format(amount / 100);
    }
    updateRow(row, selectAvailable) {
      const option = row.querySelector('select').selectedOptions[0];
      const check = row.querySelector('[data-check]');
      const available = option?.dataset.available === 'true';
      check.disabled = !available;
      if (!available) check.checked = false;
      else if (selectAvailable) check.checked = true;
      if (!option) return;
      row.querySelector('[data-price]').textContent = option.dataset.money;
      const compare = row.querySelector('[data-compare]');
      compare.textContent = option.dataset.compareMoney;
      compare.hidden = Number(option.dataset.compare) <= Number(option.dataset.price);
      row.querySelector('[data-sold]').hidden = available;
      const image = row.querySelector('img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
    }
    selected() {
      return this.rows.filter(row => {
        const check = row.querySelector('[data-check]');
        return check.checked && !check.disabled;
      }).map(row => row.querySelector('select').selectedOptions[0]);
    }
    update() {
      const selected = this.selected();
      const total = selected.reduce((sum, o) => sum + Number(o.dataset.price), 0);
      const compare = selected.reduce((sum, o) => sum + Math.max(Number(o.dataset.price), Number(o.dataset.compare)), 0);
      this.querySelector('[data-total]').textContent = this.money(total);
      const crossed = this.querySelector('[data-total-compare]');
      crossed.textContent = this.money(compare);
      crossed.hidden = compare <= total;
      this.button.disabled = this.busy || selected.length === 0;
      this.rows.forEach(row => row.classList.toggle('is-unselected', !row.querySelector('[data-check]').checked));
    }
    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      const selected = this.selected();
      if (!selected.length) return;
      this.busy = true;
      this.update();
      this.button.textContent = 'Adding…';
      this.status.textContent = '';
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: selected.map(o => ({ id: Number(o.value), quantity: 1 })) })
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'These books could not all be added.');
        }
        this.status.textContent = 'Books added. Opening your cart…';
        window.location.assign(root + 'cart');
      } catch (error) {
        this.status.textContent = (error instanceof TypeError || error instanceof SyntaxError)
          ? 'We could not confirm the cart update. Check your cart before trying again.'
          : error.message + ' Check your cart before trying again.';
        this.querySelector('[data-cart-link]').hidden = false;
        this.busy = false;
        this.button.textContent = 'Add selected to cart';
        this.update();
      }
    }
  });
}

/* Shopify supplies ranked related products; no product metafield is read. */
if (!customElements.get('bc-fbt-auto')) {
  customElements.define('bc-fbt-auto', class extends HTMLElement {
    connectedCallback() {
      if (this.loading || this.loaded) return;
      this.load();
    }
    async load() {
      this.loading = true;
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(this.dataset.url, { signal: controller.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || this.controller !== controller) return;
        const bundle = html.querySelector('bc-fbt');
        this.loaded = true;
        if (bundle) {
          this.replaceChildren(document.importNode(bundle, true));
        } else {
          this.empty('Shopify has no eligible recommendations for this book yet. This section is hidden on the storefront.');
        }
      } catch (error) {
        if (this.isConnected && this.controller === controller) {
          this.empty('Recommendations could not load. Refresh the preview to try again.');
        }
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) this.loading = false;
      }
    }
    empty(message) {
      this.replaceChildren();
      if (this.hasAttribute('data-editor')) {
        const note = document.createElement('p');
        note.textContent = message;
        this.append(note);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.loading = false;
    }
  });
}
